import { Tag } from "antd";
import { beautify } from "../../utils/helpers";
// import { blueColor } from "../styled/Theme";

export const PaymentStatusTag = ({ status }) => {
  switch (status) {
    case "paid":
    case "completed":
      return (
        <Tag color="green" style={{ background: "none" }}>
          {/* {beautify(status)} */}
          {beautify("Completed")}
        </Tag>
      );
    case "Active":
      return (
        <Tag color="green" style={{ background: "none" }}>
          {beautify("Active")}
        </Tag>
      );
    case "defaulted":
    case "not_paid":
      return (
        <Tag color="red" style={{ background: "none" }}>
          {beautify(status)}
        </Tag>
      );
    case "partially_paid":
      return (
        <Tag style={{ background: "none" }}>
          {/* {beautify(status)} */}
          {beautify("Running")}
        </Tag>
      );
    case "not_available":
      return (
        <Tag color="gray" style={{ background: "none" }}>
          {beautify(status)}
        </Tag>
      );
    default:
      return <Tag style={{ background: "none" }}>{beautify(status)}</Tag>;
  }
};

export const PaymentItemTag = ({ item_name }) => {
  switch (item_name) {
    case "MTN deposits":
      return (
        <Tag
          style={{
            background: "#f6ffed",
            color: "#389e0d",
            border: "1px solid #b7eb8f",
          }}
        >
          {beautify(item_name)}
        </Tag>
      );
    case "NWSC":
      return (
        <Tag
          style={{
            background: "#e6fffb",
            color: "#08979c",
            border: "1px solid #87e8de",
          }}
        >
          {beautify(item_name)}
        </Tag>
      );
    case "URA":
      return (
        <Tag
          style={{
            background: "#f5f5f5",
            color: "#8c8c8c",
            border: "1px solid #d9d9d9",
          }}
        >
          {beautify(item_name)}
        </Tag>
      );
    case "AIRTEL deposits":
      return (
        <Tag
          style={{
            background: "#fffbe6",
            color: "#faad14",
            border: "1px solid #ffe58f",
          }}
        >
          {beautify(item_name)}
        </Tag>
      );
    case "Wallent Payment":
      return (
        <Tag
          style={{
            background: "#e6fffb",
            color: "#08979c",
            border: "1px solid #87e8de",
          }}
        >
          {beautify(item_name)}
        </Tag>
      );
    default:
      return <Tag style={{ background: "none" }}>{beautify(item_name)}</Tag>;
  }
};

export const TransactionChannelTag = ({ channel }) => {
  switch (channel) {
    case "App&Web":
      return (
        <Tag
          style={{
            background: "#f6ffed",
            color: "#389e0d",
            border: "1px solid #b7eb8f",
          }}
        >
          {beautify(channel)}
        </Tag>
      );
    case "QRCode":
      return (
        <Tag
          style={{
            background: "#e6fffb",
            color: "#08979c",
            border: "1px solid #87e8de",
          }}
        >
          {beautify(channel)}
        </Tag>
      );
    case "MerchantCode":
      return (
        <Tag
          style={{
            background: "#f5f5f5",
            color: "#8c8c8c",
            border: "1px solid #d9d9d9",
          }}
        >
          {beautify(channel)}
        </Tag>
      );
    case "API":
      return (
        <Tag
          style={{
            background: "#fffbe6",
            color: "#faad14",
            border: "1px solid #ffe58f",
          }}
        >
          {beautify(channel)}
        </Tag>
      );
    default:
      return <Tag style={{ background: "none" }}>{beautify(channel)}</Tag>;
  }
};

export const TransactionStatusTag = ({ status }) => {
  switch (status) {
    case "SUCCESSFUL":
    case "SUCCESS":
      return (
        <Tag
          style={{
            background: "#f6ffed",
            color: "#389e0d",
            border: "1px solid #b7eb8f",
          }}
        >
          {beautify(status)}
        </Tag>
      );
    case "APPROVED":
      return (
        <Tag
          style={{
            background: "#f6ffed",
            color: "#389e0d",
            border: "1px solid #b7eb8f",
          }}
        >
          {beautify(status)}
        </Tag>
      );
    case "SETTLED":
      // Deep teal-green — distinct from plain "success", signals finality
      return (
        <Tag
          style={{
            background: "#e6fffb",
            color: "#08979c",
            border: "1px solid #87e8de",
          }}
        >
          {beautify(status)}
        </Tag>
      );
    case "PENDING":
      return (
        <Tag
          style={{
            background: "#f5f5f5",
            color: "#8c8c8c",
            border: "1px solid #d9d9d9",
          }}
        >
          {beautify(status)}
        </Tag>
      );
    case "PENDING_APPROVAL":
      // Amber — needs attention, but not alarming
      return (
        <Tag
          style={{
            background: "#fffbe6",
            color: "#d48806",
            border: "1px solid #ffe58f",
          }}
        >
          {beautify(status)}
        </Tag>
      );
    case "DRAFT":
      // Neutral gray — inactive, not yet submitted
      return (
        <Tag
          style={{
            background: "#f5f5f5",
            color: "#595959",
            border: "1px solid #d9d9d9",
          }}
        >
          {beautify(status)}
        </Tag>
      );
    case "SENT_TO_BANK":
      // Cyan — "in transit", distinct from the darker processing blue
      return (
        <Tag
          style={{
            background: "#e6f4ff",
            color: "#0958d9",
            border: "1px solid #91caff",
          }}
        >
          {beautify(status)}
        </Tag>
      );
    case "POSTED":
      return (
        <Tag
          style={{
            background: "#f0f5ff",
            color: "#2f54eb",
            border: "1px solid #adc6ff",
          }}
        >
          {beautify(status)}
        </Tag>
      );
    case "PROCESSING":
      return (
        <Tag
          style={{
            background: "#e6f7ff",
            color: "#096dd9",
            border: "1px solid #91d5ff",
          }}
        >
          {beautify(status)}
        </Tag>
      );
    case "FAILED":
      return (
        <Tag
          style={{
            background: "#fff2f0",
            color: "#cf1322",
            border: "1px solid #ffa39e",
          }}
        >
          {beautify(status)}
        </Tag>
      );
    default:
      return (
        <Tag
          style={{
            background: "#f5f5f5",
            color: "#8c8c8c",
            border: "1px solid #d9d9d9",
          }}
        >
          {beautify(status)}
        </Tag>
      );
  }
};

export const SeverityTag = ({ severity }) => {
  switch (severity) {
    case "LOW":
      return (
        <Tag color="green" style={{ background: "none" }}>
          {beautify(severity)}
        </Tag>
      );
    case "MEDIUM":
      return (
        <Tag color="yellow" style={{ background: "none" }}>
          {beautify(severity)}
        </Tag>
      );
    case "HIGH":
      return (
        <Tag color="orange" style={{ background: "none" }}>
          {beautify(severity)}
        </Tag>
      );
    case "CRITICAL":
      return (
        <Tag color="red" style={{ background: "none" }}>
          {beautify(severity)}
        </Tag>
      );
    default:
      return <Tag style={{ background: "none" }}>{beautify(severity)}</Tag>;
  }
};

export const ActionTypeTag = ({ action_type }) => {
  switch (action_type) {
    case "FREEZE":
      return (
        <Tag color="blue" style={{ background: "none" }}>
          {beautify(action_type)}
        </Tag>
      );
    case "UNFREEZE":
      return (
        <Tag color="yellow" style={{ background: "none" }}>
          {beautify(action_type)}
        </Tag>
      );
    case "BLOCK":
      return (
        <Tag color="red" style={{ background: "none" }}>
          {beautify(action_type)}
        </Tag>
      );
    case "UNBLOCK":
      return (
        <Tag color="yellow" style={{ background: "none" }}>
          {beautify(action_type)}
        </Tag>
      );
    case "ALERT":
      return (
        <Tag color="gray" style={{ background: "none" }}>
          {beautify(action_type)}
        </Tag>
      );
    default:
      return <Tag style={{ background: "none" }}>{beautify(action_type)}</Tag>;
  }
};

export const BooleanTags = ({ status }) => {
  if (status == true) {
    return (
      <Tag color="green" style={{ background: "none" }}>
        True
      </Tag>
    );
  } else {
    return (
      <Tag color="red" style={{ background: "none" }}>
        False
      </Tag>
    );
  }
};

export const StatusTags = ({ status }) => {
  if (status == "active" || status == "Active") {
    return (
      <Tag color="success" style={{ background: "none" }}>
        {beautify(status)}
      </Tag>
    );
  } else {
    return (
      <Tag color="red" style={{ background: "none" }}>
        {beautify(status)}
      </Tag>
    );
  }
};

export const StatusTag = ({ status }) => {
  switch (status) {
    case "approved":
      return (
        <Tag color="green" style={{ background: "none", width: 80 }}>
          {beautify(status)}
        </Tag>
      );
    case "resolved":
      return (
        <Tag color="green" style={{ background: "none", width: 80 }}>
          {beautify(status)}
        </Tag>
      );
    case "closed":
      return (
        <Tag color="orange" style={{ background: "none", width: 80 }}>
          {beautify(status)}
        </Tag>
      );
    case "rejected":
      return (
        <Tag color="red" style={{ background: "none", width: 80 }}>
          {beautify(status)}
        </Tag>
      );
    case "pending":
      return (
        <Tag color="black" style={{ background: "gray", width: 80 }}>
          {beautify(status)}
        </Tag>
      );
    case "draft":
      return (
        <Tag color="gray" style={{ background: "gray", width: 80 }}>
          {beautify(status)}
        </Tag>
      );
    default:
      return (
        <Tag style={{ background: "none", width: 80 }}>{beautify(status)}</Tag>
      );
  }
};
